export const getAttachmentFileEndpoint = '/berths/booking/attachment' as const
